export default "__VITE_ASSET__DRk0nYOM__"